import { render } from "./CourseRecord.vue?vue&type=template&id=6f79d0fb&scoped=true"
import script from "./CourseRecord.vue?vue&type=script&lang=js"
export * from "./CourseRecord.vue?vue&type=script&lang=js"

import "./CourseRecord.vue?vue&type=style&index=0&id=6f79d0fb&lang=scss&scoped=true"
import "./CourseRecord.vue?vue&type=style&index=1&id=6f79d0fb&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f79d0fb"]])

export default __exports__